import React from 'react';
import classNames from 'classnames';
import { makeStyles } from '@mui/styles';

import claps from '../../assets/emoji/claps.png';
import confettiBall from '../../assets/emoji/confetti-ball.png';
import indexPointingUp from '../../assets/emoji/index-pointing-up.png';
import partyFace from '../../assets/emoji/party-face.png';
import partyPopper from '../../assets/emoji/party-popper.png';
import sleepyFace from '../../assets/emoji/sleepy-face.png';
import foldedHands from '../../assets/emoji/folded-hands.png';
import cryingFace from '../../assets/emoji/crying-face.png';
import checkMark from '../../assets/emoji/check-mark.png';
import boxPackage from '../../assets/emoji/package.png';
import spiralCalendar from '../../assets/emoji/spiral-calendar.png';
import wrappedGift from '../../assets/emoji/wrapped-gift.png';
import information from '../../assets/emoji/information.png';
import heartWithRibbon from '../../assets/emoji/heart-with-ribbon.png';

const emojiAliases = {
  claps,
  confettiBall,
  indexPointingUp,
  partyFace,
  partyPopper,
  sleepyFace,
  foldedHands,
  cryingFace,
  checkMark,
  boxPackage,
  spiralCalendar,
  wrappedGift,
  information,
  heartWithRibbon,
};

export type TEmojiKey = keyof typeof emojiAliases;

const useStyles = makeStyles(({ spacing }) => ({
  emoji: {
    display: 'inline-block',
    marginRight: spacing(1),
  },
}));

export interface IEmojiProps {
  emoji: TEmojiKey;
  width?: number;
  height?: number;
  overrideSpanClass?: string;
  imageProps?: Partial<React.ImgHTMLAttributes<HTMLImageElement>>;
}

const Emoji = ({
  emoji,
  width = 32,
  height = 32,
  overrideSpanClass = '',
  imageProps = {},
}: IEmojiProps): JSX.Element => {
  const classes = useStyles();

  const emojiImage = emojiAliases[emoji] || '';

  return (
    <span className={classNames(classes.emoji, overrideSpanClass)}>
      <img src={emojiImage} alt={`Emoji ${emoji}`} width={width} height={height} {...imageProps} />
    </span>
  );
};

export default Emoji;
